import type { SynthesisSessionRepository } from "../repositories/synthesis-session-repository"

export const makeGetSynthesisSession = (repo: SynthesisSessionRepository) =>
  (id: string) => repo.getById(id)
